import { handleActions } from "redux-actions";
import {
  SEARCH_ALL_USERS,
  SEARCH_ALL_USERS_SUCCESS,
  SEARCH_ALL_USERS_FAILURE,
  APPROVAL_USER,
  APPROVAL_USER_SUCCESS,
  APPROVAL_USER_FAILURE,
  APPROVAL_USER_INIT,
  UPDATE_USE_YN,
  UPDATE_USE_YN_SUCCESS,
  UPDATE_USE_YN_FAILURE,
  UPDATE_USE_YN_INIT,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_INIT
} from "../actionCreators";

const initialState = {
  userList: [],
  isLoading: false,
  searchError: null,

  approvalResult: null,
  approvalError: null,
  isApprovalLoading: false,

  useYnResult: null,
  useYnError: null,
  isUseYnLoading: false,

  deleteResult: null,
  deleteError: null,
  isDeleteLoading: false
};

const userManagementReducer = handleActions(
  {
    [SEARCH_ALL_USERS]: state => ({
      ...state,
      isLoading: true,
      searchError: null
    }),
    [SEARCH_ALL_USERS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      userList: (data && data.userList) || [],
      isLoading: false,
      searchError: null
    }),
    [SEARCH_ALL_USERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isLoading: false,
      searchError: error
    }),

    [APPROVAL_USER]: state => ({
      ...state,
      isApprovalLoading: true,
      approvalResult: null,
      approvalError: null
    }),
    [APPROVAL_USER_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      isApprovalLoading: false,
      approvalResult: data.result,
      approvalError: null
    }),
    [APPROVAL_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isApprovalLoading: false,
      approvalError: error
    }),
    [APPROVAL_USER_INIT]: state => ({
      ...state,
      isApprovalLoading: false,
      approvalResult: null,
      approvalError: null
    }),

    [UPDATE_USE_YN]: state => ({
      ...state,
      isUseYnLoading: true,
      useYnResult: null,
      useYnError: null
    }),
    [UPDATE_USE_YN_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      isUseYnLoading: false,
      useYnResult: data.result,
      useYnError: null
    }),
    [UPDATE_USE_YN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isUseYnLoading: false,
      useYnError: error
    }),
    [UPDATE_USE_YN_INIT]: state => ({
      ...state,
      isUseYnLoading: false,
      useYnResult: null,
      useYnError: null
    }),

    [DELETE_USER]: state => ({
      ...state,
      isDeleteLoading: true,
      deleteResult: null,
      deleteError: null
    }),
    [DELETE_USER_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      isDeleteLoading: false,
      deleteResult: data.result,
      deleteError: null
    }),
    [DELETE_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isDeleteLoading: false,
      deleteError: error
    }),
    [DELETE_USER_INIT]: state => ({
      ...state,
      isDeleteLoading: false,
      deleteResult: null,
      deleteError: null
    })
  },
  initialState
);

export default userManagementReducer;
